import { render, staticRenderFns } from "./AccelerationFactor.vue?vue&type=template&id=01c270b8&scoped=true&"
import script from "./AccelerationFactor.vue?vue&type=script&lang=js&"
export * from "./AccelerationFactor.vue?vue&type=script&lang=js&"
import style0 from "./AccelerationFactor.vue?vue&type=style&index=0&id=01c270b8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c270b8",
  null
  
)

export default component.exports